<template>
  <div/>
</template>

<script>
import L from 'leaflet'
import chroma from 'chroma-js'

const normalizeValue = (value, min, max) => (value - min) / (max - min)

export default {
  props: {
    item: Object,
    unit: String,
    secondaryUnit: String,
    placeholder: {
      type: String,
      default: '',
    },
    title: String,
    name: String,
    areaTitle: String,
    position: {
      type: String,
      default: 'bottomleft',
    },
    valueBounds: Object,
    colorScale: Array,
  },
  mounted() {
    const { unit, secondaryUnit, title, item, placeholder, position } = this

    this.mapObject = L.control({
      position: position,
    })
    this.mapObject.onAdd = function() {
      this._div = L.DomUtil.create('div', 'info-control active')
      this.update({
        name: '',
        item,
        value: 0,
        unit,
        secondaryUnit,
        placeholder,
        title,
      })
      return this._div
    }
    this.mapObject.update = function({
      name,
      item,
      unit,
      secondaryUnit,
      valueBounds,
      areaTitle,
      colorScale,
    }) {
      if (name.length > 0) {
        const barColor = chroma
          .scale(colorScale)
          .mode('lch')(
            normalizeValue(item.value, valueBounds.min, valueBounds.max)
          )
          .hex()
        this._div.innerHTML = `<b> ${areaTitle} </b> <br /> ${unit} <br /> ${secondaryUnit} <br /> <div class="budget-bar" style="background-color:${barColor}" />`
      } else {
        this._div.innerHTML = `
          <b>Companies with development support</b> <br/>
          Explore markers for individual companies <br/>
          Country colours show reach of development projects
        `
      }
    }

    if (this.$parent._isMounted) {
      this.deferredMountedTo(this.$parent.mapObject)
    }
  },
  methods: {
    deferredMountedTo(parent) {
      this.parent = parent
      this.mapObject.addTo(parent)
    },
  },
  watch: {
    item: function(newValue) {
      this.mapObject.update({
        ...newValue,
        unit: this.unit,
        secondaryUnit: this.secondaryUnit,
        valueBounds: this.valueBounds,
        item: this.item,
        title: this.title,
        placeholder: this.placeholder,
        areaTitle: this.areaTitle,
        colorScale: this.colorScale,
      })
    },
  },
  beforeDestroy() {
    if (this.parent) {
      this.parent.removeControl(this.mapObject)
    }
  },
}
</script>
<style>
.info-control {
  padding: 10px 14px;
  margin: 10px;
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  display: none;
  font-size: 14px;
}
.info-control.active {
  display: block;
}
.info-control b {
  display: inline-block;
  padding-bottom: 5px;
}
.budget-bar {
  height: 3px;
  margin-top: 8px;
}
</style>
